// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { Typography, Box, Grid, CircularProgress, Paper } from '@mui/material';
import einsteinImage from '../assets/einstein.jpg'; // 画像のインポート
import TokenomicsChart from './TokenomicsChart';
import SwapTokens from './SwapTokens';
import YourReward from './YourReward';
import { useAuth } from '../context/AuthContext';


const TOKEN_MINT_ADDRESS = 'Gc3eJ7fhAaJR2YsxyNs9nCb4HydBiLryKGxghW613sYK';

const Home = () => {
  const { authSuccess } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 
  

  return (
    <Box
      sx={{
        textAlign: 'center',
        color: 'text.primary',
        backgroundImage: 'radial-gradient(circle at top, #0f2027 0%, #203a43 50%, #2c5364 100%)',
        padding: { xs: 3, md: 6 },
        borderRadius: 2,
        boxShadow: 4,
        maxWidth: 1200,
        margin: 'auto',
        my: 4,
      }}
    >
      <Grid container spacing={4} alignItems="top" justifyContent="center">
        {/* 画像セクション */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={einsteinImage}
            alt="Albert Einstein"
            sx={{
              width: '100%',
              maxWidth: 400,
              height: 'auto',
              borderRadius: 2,
              boxShadow: 3,
              margin: 'auto',
            }}
          />
        </Grid>

        {/* テキストセクション */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontFamily: 'Merriweather, serif',
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            "The true sign of intelligence is not knowledge, but imagination."
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Caveat, cursive',
              color: 'lightgray',
              fontStyle: 'italic',
              mt: 2,
            }}
          >
            — Albert Einstein
          </Typography>
          <Box sx={{ my: 4 }}>
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Open Sans, sans-serif',
                color: 'white',
                lineHeight: 1.6,
              }}
            >
              We recognize and honor those who dare to tackle the most profound challenges. By fostering a community of visionary thinkers, we aim to inspire breakthroughs that will transform our world.
            </Typography>
            <Typography
  variant="body1"
  sx={{
    fontFamily: 'Open Sans, sans-serif',
    color: 'white',
    lineHeight: 1.6,
    mb: 1,
    wordBreak: 'break-all', // ここを追加
  }}
>
  SOL: {TOKEN_MINT_ADDRESS}
</Typography>

          </Box>
</Grid>

           
            {!authSuccess ? (
              <Grid item xs={12} md={12}>
              {/* トークン情報セクション（Paper で囲む） */}
              <Paper
                sx={{
                  backgroundColor: "#002F2F",
                  borderRadius: 2,
                  p: 3,
                  my: 4,
                  border: "1px solid rgba(0, 255, 255, 0.3)",
                  boxShadow: "0px 0px 25px rgba(0, 255, 255, 0.5)"
                }}
              >
                <Typography
        variant="h4"
        gutterBottom
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
       Your Balance
      </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: 'Open Sans, sans-serif',
                  color: 'white',
                  lineHeight: 1.6,
                  fontWeight:"bold"
                }}
              >
                Your wallet is not connected
              </Typography>
              </Paper>
              </Grid>
            ) : loading ? (
              <CircularProgress sx={{ color: 'white' }} />
            ) : error ? (

              <Grid item xs={6} md={6}>
              {/* トークン情報セクション（Paper で囲む） */}
              <Paper
                sx={{
                  backgroundColor: "#002F2F",
                  borderRadius: 2,
                  p: 3,
                  my: 4,
                  border: "1px solid rgba(0, 255, 255, 0.3)",
                  boxShadow: "0px 0px 25px rgba(0, 255, 255, 0.5)"
                }}
              >
                <Typography
        variant="h4"
        gutterBottom
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
       Your Balance
      </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: 'Open Sans, sans-serif',
                  color: 'red',
                  lineHeight: 1.6,
                  fontWeight:"bold"
                }}
              >
                Error is occurred
              </Typography>
              </Paper>
              </Grid>
             
            ) : (
              <>
             
             <Grid item xs={12} md={6}>
              {/* トークン情報セクション（Paper で囲む） */}
              <Paper
                sx={{
                  backgroundColor: "#002F2F",
                  borderRadius: 2,
                  p: 3,
                  my: 4,
                  border: "1px solid rgba(0, 255, 255, 0.3)",
                  boxShadow: "0px 0px 25px rgba(0, 255, 255, 0.5)"
                }}
              >
               <SwapTokens/>
              </Paper>
             </Grid>
             <Grid item xs={12} md={6}>
             <Paper
                sx={{
                  backgroundColor: "#002F2F",
                  borderRadius: 2,
                  p: 3,
                  my: 4,
                  border: "1px solid rgba(0, 255, 255, 0.3)",
                  boxShadow: "0px 0px 25px rgba(0, 255, 255, 0.5)"
                }}
              >
                <YourReward/>
                </Paper>
                </Grid>
             </>
            )}
         

        {/* Tokenomics Chart セクション */}
        <Grid item xs={12} md={12} alignItems="center" justifyContent="center">
          <TokenomicsChart />
        </Grid>

        {/* フッターセクション */}
        <Grid item xs={12} md={12} alignItems="center" justifyContent="center">
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Open Sans, sans-serif',
              color: 'white',
              lineHeight: 1.6,
            }}
          >
            © 2025 Albert Einstein. All Rights Reserved.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
